import React, { useEffect, useRef, useState } from 'react';
import { Image } from '../../../../AbstractElements';
import { Fragment } from 'react';
import Slider from 'react-slick';
import { Media } from 'reactstrap';

const ImageSlider = ({ event }) => {
  const slider1 = useRef(null);
  const slider2 = useRef(null);

  // Default event image if no images provided
  const defaultImage = 'https://via.placeholder.com/400x300/6c757d/ffffff?text=No+Image';
  
  // Get event images
  const getEventImages = () => {
    if (!event) return [defaultImage];
    
    const images = [];
    
    // Check for new API format: event.img[].url
    if (event.img && Array.isArray(event.img)) {
      event.img.forEach(imgObj => {
        if (imgObj && imgObj.url && typeof imgObj.url === 'string' && imgObj.url.trim() !== '') {
          images.push(imgObj.url);
        }
      });
    }
    
    // Check for new API format: event.description.media[].url
    if (event.description && event.description.media && Array.isArray(event.description.media)) {
      event.description.media.forEach(mediaObj => {
        if (mediaObj && mediaObj.url && typeof mediaObj.url === 'string' && mediaObj.url.trim() !== '') {
          images.push(mediaObj.url);
        }
      });
    }
    
    // Add event images if available (old format)
    if (event.eventImages && Array.isArray(event.eventImages)) {
      event.eventImages.forEach(img => {
        if (img && typeof img === 'string' && img.trim() !== '') {
          images.push(img);
        }
      });
    }
    
    // Add description images if available (old format)
    if (event.descriptionImages && Array.isArray(event.descriptionImages)) {
      event.descriptionImages.forEach(img => {
        if (img && typeof img === 'string' && img.trim() !== '') {
          images.push(img);
        }
      });
    }
    
    // If no valid images, use default
    if (images.length === 0) {
      images.push(defaultImage);
    }
    
    return images;
  };

  const eventImages = getEventImages();

  return (
    <Fragment>
      <Slider 
        asNavFor={slider2.current} 
        className='product-slider' 
        arrows={false} 
        ref={slider1}
      >
        {eventImages.map((image, id) => (
          <div key={id} className="slider-item">
            <Image
              attrImage={{
                src: image,
                alt: event?.title || 'Event Image',
                className: 'img-fluid w-100',
                style: { minHeight: '300px', objectFit: 'cover' },
                onError: (e) => {
                  console.warn('Image load error:', image);
                  e.target.src = defaultImage;
                },
                onLoad: () => {
                }
              }}
            />
          </div>
        ))}
      </Slider>
      <Slider 
        asNavFor={slider1.current} 
        ref={slider2} 
        slidesToShow={4} 
        swipeToSlide={true} 
        focusOnSelect={true} 
        infinite={true} 
        className='small-slick'
      >
        {eventImages.map((image, id) => (
          <div key={id} className="thumbnail-item">
            <Image
              attrImage={{
                src: image,
                alt: event?.title || 'Event Image',
                className: 'img-fluid item',
                style: { minHeight: '80px', objectFit: 'cover' },
                onError: (e) => {
                  console.warn('Thumbnail load error:', image);
                  e.target.src = defaultImage;
                }
              }}
            />
          </div>
        ))}
      </Slider>
    </Fragment>
  );
};
export default ImageSlider;
